import { ReportsModule } from "@/modules/reports-objective";
import { Vue, Component } from "vue-property-decorator";
import Grid from "@/components/wijmo-grid/grid/grid.vue";
import { getInnerHtmlFromText, getRouteAccessLevel } from "@/util/func";
import { fmtMsg } from "commonui";
import { ReportsLocale } from "@/locales/localeid";
import { AccessLevel } from "@/util/enum";
import { MediaSlotTypeMapForView } from "@/util/constants";
import { CellType } from "wijmo/wijmo.grid";
import { setAttribute } from "wijmo/wijmo";
import { IWorkbookCell } from "wijmo/wijmo.xlsx";

@Component({
	components: { Grid }
})
export default class MediaChangeImpact extends Vue {
	accessLevel = AccessLevel;
	private mediaTypeIdBinding = "mediaTypeId";

	get currentRouteAccessLevel() {
		return getRouteAccessLevel(this.$route);
	}

	get isGridLoading() {
		return ReportsModule.mediaChangeImpactReportGridLoading;
	}

	gridData() {
		return ReportsModule.mediaChangeImpactReportData;
	}

	get exportOptions() {
		return {
			filename: fmtMsg(ReportsLocale.ReportsMediaChangeImpactExportedFileName),
			noDataMessage: fmtMsg(ReportsLocale.ReportsMediaChangeImpactNoDataExportExcelWarning),
			formatCell: (cell: IWorkbookCell, binding: string) => {
				if (cell.value && binding == this.mediaTypeIdBinding) {
					cell.value = this.mediaType(cell.value);
				}
				if (cell.value && binding == "text") {
					cell.value = getInnerHtmlFromText(cell.value);
				}
			}
		};
	}

	mediaType(mediaTypeId: number) {
		return MediaSlotTypeMapForView[mediaTypeId];
	}

	initGrid(grid) {
		grid.formatItem.addHandler((s, e) => {
			if (e.panel.cellType == CellType.ColumnHeader) {
				setAttribute(e.cell, "title", e.cell.outerText);
			}
		});
	}

	beforeDestroy() {
		ReportsModule.setMediaChangeImpactReportData([]);
	}
}
